import { Button, Tooltip } from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import DynamicFeedRoundedIcon from "@mui/icons-material/DynamicFeedRounded";
import {useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import {Section as SectionType} from '../../common/types/post.types';
import {formatDate} from "../../utils/utils";
import { useEffect, useState } from "react";
import { ResponsePostStatisticType } from "../../common/types/api.types";
import { getPostStatisticApi } from "../../utils/api";
import {getImageUrl} from "../../utils/post-utils";

function BigSection() {
  const sections: SectionType[] = useSelector((state: any) => state.sections.data)
  const [postStatistic, setPostStatistic] = useState<ResponsePostStatisticType[]>(null)

  useEffect(() => {
    getPostStatisticApi().then(data => {
      setPostStatistic(data);
    })
  }, []);

  const getTotalPost = (sectionId: number) => {
    return postStatistic?.find(each => each.section_id === sectionId)?.count ?? 0;
  }

  const listSections = sections.map((section: SectionType, index: number) => {
    return <Section section={section} totalPost={getTotalPost(section.id)} key={index}/>
  })

  return (
    <div className={"big-section"}>
      {listSections}
    </div>
  );
}

export default BigSection;

function Section(props: Props) {
  const navigate = useNavigate();
  const {section, totalPost} = props;

  function goToSection() {
    if (section.path === 'portfolio') {
      navigate('/portfolio');
    } else {
      navigate(`/sections/${section.path}`)
    }
  }

  return (
    <Button onClick={goToSection}>
      <img src={getImageUrl(section.icon)} className={"icon"} alt={section.name}/>
      <div>
        <div className={"title"}>{section.name}</div>
        <div className={"details"}>
          <Tooltip title="Total topics">
            <span>
              <DynamicFeedRoundedIcon className={"icon"} />
              {totalPost} topics
            </span>
          </Tooltip>
          <Tooltip title="Last update">
            <span className={'last-update'}>
              <AccessTimeRoundedIcon className={"icon"} />
              {formatDate(section.updated_at)}
            </span>
          </Tooltip>
        </div>
      </div>
    </Button>
  );
}

class Props {
  section: SectionType;
  totalPost: number;
}
